<template>
  <el-table-column
    prop="locations"
    label="Területek"
    min-width="130"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tooltip v-if="scope.row.locations.length" placement="top" style="max-width: 300px;" popper-class="permission-info-tooltip" :disabled="!scope.row.locations.length">
        <div slot="content">
          {{ scope.row.locations.map(l => l.value).join(', ') }}
        </div>
        <el-tag type="primary" size="small"> {{ scope.row.locations.length }} terület </el-tag>
      </el-tooltip>
      <el-tag v-if="!scope.row.locations.length" type="danger" size="small">Nincs terület</el-tag>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'locations',
  };
</script>
